import type { JobStatus } from '@/features/jobs/types';

const ACTIVE_PLAN_FIELDS = new Set([
  'jobNumber',
  'jobKind',
  'startDate',
  'endDate',
  'serviceTypeIds',
]);

export function areJobPlanFieldsReadOnly(status: JobStatus) {
  return status === 'active' || status === 'archived';
}

export function containsActiveJobPlanField(patch: Record<string, unknown>) {
  return Object.keys(patch).some((field) => ACTIVE_PLAN_FIELDS.has(field));
}
